import SignListEditorContainer from './containers/SignListEditorContainer'

export default SignListEditorContainer
